export enum ShortcutId {
  Search = 'Search::ShortcutId',
  CopyTradeGoto = 'CopyTradeGoto::ShortcutId',
  Settings = 'Settings::ShortcutId',
  Profile = 'Profile::ShortcutId',
  OpenClipboardPair = 'OpenClipboardPair::ShortcutId',
}
